import type { QueueItem } from '../queue';
import type { IQueueStorage, StorageHealth } from './IQueueStorage';

let memory: QueueItem[] = [];

export class MemoryQueueStorage implements IQueueStorage {
  readonly name = 'memory';

  async loadAll(): Promise<QueueItem[]> {
    return [...memory];
  }

  async saveAll(items: QueueItem[]): Promise<void> {
    memory = [...items];
  }

  async put(item: QueueItem): Promise<void> {
    const idx = memory.findIndex(i => i.id === item.id);
    if (idx >= 0) memory[idx] = item;
    else memory.push(item);
  }

  async delete(id: string): Promise<void> {
    memory = memory.filter(i => i.id !== id);
  }

  async health(): Promise<StorageHealth> {
    return { ok: true, backend: 'memory', itemCount: memory.length };
  }
}

export function _testSetMemoryStorage(items: QueueItem[]): void {
  memory = items;
}
